<template>
    <div contenteditable="false" class="chip-wrapper non-editable green">
          <span class="no-visible"> %%{{ value }}- </span>
          <span> {{ name }} </span>
          <span class="no-visible"> %% </span>
    </div>
</template>

<script>
export default {
  name: 'chiptextDataField',
  props: {
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
}

</script>

<style lang="scss" scoped>
.no-visible {
  display: none;
  align-items: center;
  visibility: hidden;
  width: 0;
  height: 0;
}

.chip-wrapper {
  display: inline-block;
  justify-content: center;
  align-items: center;
  color: var(--primary) !important;
  background-color: var(--clear) !important;
  border: 1.5px solid var(--primary) !important;
  border-radius: 4px;
  max-height: 19px;
  font-weight: bold;
  font-size: 13px;
}

.non-editable {
  pointer-events: none;
  user-select: none;
}
</style>
